export default "<ng-container *ngIf=\"show\">\n    <div class=\"spinner\"></div>\n</ng-container>\n";